var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Box, Button, IconButton, MenuItem, Divider } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { MODOS, MENSAGENS } from '../../../utils';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import ContainerPainel from '../../../components/container_painel';
import { BoxPrincipal, BoxBotoes } from '../../../components/form_box';
import Loading from '../../../components/loading';
import { useNavigate, useParams } from 'react-router-dom';
import { getFuncionalidade, cadastrarFuncionalidade, alterarFuncionalidade, excluirFuncionalidade, getFuncionalidadesAcoesAtivos } from '../../../api';
import { BotaoSalvar, BotaoExcluir, BotaoFechar, BotaoEditar } from '../../../components/botoes';
import InputDados from '../../../components/input_dados';
import { useAuth } from '../../../contexts/auth/AuthContext';
var FuncionalidadesEditar = function () {
    var addMensagem = useAuth().addMensagem;
    var navigate = useNavigate();
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(true), LoadingInicio = _b[0], setLoadingInicio = _b[1];
    var _c = useParams(), id = _c.id, modo = _c.modo;
    var _d = useState([]), AcoesDisponiveis = _d[0], setAcoesDisponiveis = _d[1];
    var _e = useState([]), AcoesSelecionadas = _e[0], setAcoesSelecionadas = _e[1];
    var _f = useState(''), Nome = _f[0], setNome = _f[1];
    var _g = useState(''), Chave = _g[0], setChave = _g[1];
    var _h = useState(''), Rota = _h[0], setRota = _h[1];
    var _j = useState(null), Descricao = _j[0], setDescricao = _j[1];
    var _k = useState('Ativo'), Situacao = _k[0], setSituacao = _k[1];
    var DESABILITAR_CAMPOS = modo == MODOS.VISUALIZAR || modo == MODOS.EXCLUIR;
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var AcoesAux, FuncionalidadeAux, nome, chave, rota, descricao, acoes, situacao;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getFuncionalidadesAcoesAtivos()];
                case 1:
                    AcoesAux = _a.sent();
                    setAcoesDisponiveis(AcoesAux);
                    if (!id) return [3 /*break*/, 3];
                    return [4 /*yield*/, getFuncionalidade(id)];
                case 2:
                    FuncionalidadeAux = _a.sent();
                    if (FuncionalidadeAux) {
                        nome = FuncionalidadeAux.nome, chave = FuncionalidadeAux.chave, rota = FuncionalidadeAux.rota, descricao = FuncionalidadeAux.descricao, acoes = FuncionalidadeAux.acoes, situacao = FuncionalidadeAux.situacao;
                        setNome(nome);
                        setChave(chave);
                        setRota(rota);
                        setDescricao(descricao);
                        setAcoesSelecionadas(acoes);
                        setSituacao(situacao);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setAcoesSelecionadas(AcoesAux);
                    _a.label = 4;
                case 4:
                    setLoadingInicio(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var validarDados = function () {
        if (!Nome || Nome.trim() == '') {
            alert("Nome ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        return true;
    };
    var salvarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resp, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!validarDados())
                        return [2 /*return*/];
                    setLoading(true);
                    Dados = {
                        nome: Nome,
                        rota: Rota,
                        descricao: Descricao,
                        acoes: AcoesSelecionadas,
                        situacao: Situacao,
                    };
                    _a = modo;
                    switch (_a) {
                        case MODOS.CADASTRAR: return [3 /*break*/, 1];
                        case MODOS.ALTERAR: return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 5];
                case 1: return [4 /*yield*/, cadastrarFuncionalidade(Dados)];
                case 2:
                    Resp = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, alterarFuncionalidade(Dados, id !== null && id !== void 0 ? id : '')];
                case 4:
                    Resp = _b.sent();
                    return [3 /*break*/, 5];
                case 5:
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        addMensagem(modo == MODOS.CADASTRAR ? MENSAGENS.REGISTRO_CADASTRADO_SUCESSO : MENSAGENS.REGISTRO_ALTERADO_SUCESSO);
                        navigate(ROUTES.FUNCIONALIDADES);
                    }
                    else if (Resp) {
                        alert(Resp.Mensagem);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var excluirRegistro = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm(MENSAGENS.EXCLUIR_REGISTRO))
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, excluirFuncionalidade(id !== null && id !== void 0 ? id : '')];
                case 1:
                    Resp = _a.sent();
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        addMensagem(MENSAGENS.REGISTRO_EXCLUIDO_SUCESSO);
                        navigate(ROUTES.FUNCIONALIDADES);
                    }
                    else if (Resp) {
                        alert(Resp.Mensagem);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var editarRegistro = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            navigate("".concat(ROUTES.FUNCIONALIDADES, "/").concat(id, "/").concat(MODOS.ALTERAR));
            return [2 /*return*/];
        });
    }); };
    var removerAcao = function (ID) {
        console.log('AcoesSelecionadas', JSON.stringify(AcoesSelecionadas));
        var AcoesAtualizadas = AcoesSelecionadas.filter(function (Item) { return Item.id != ID; });
        setAcoesSelecionadas(AcoesAtualizadas);
    };
    return (_jsx(ContainerPainel, __assign({ modo: modo, pagina_acima: PAGINAS.FUNCIONALIDADES, pagina_especifica_permissao: FUNCIONALIDADES.FUNCIONALIDADES, link_pagina_acima: ROUTES.FUNCIONALIDADES }, { children: _jsxs(BoxPrincipal, { children: [!LoadingInicio && (_jsxs(_Fragment, { children: [_jsx(InputDados, { id: 'id', variant: 'outlined', disabled: true, label: 'C\u00F3digo', value: id, size: 'small' }), id && _jsx(InputDados, { id: 'chave', variant: 'outlined', disabled: true, label: 'Chave', value: Chave, size: 'small' }), _jsx(InputDados, { id: 'nome', label: 'Nome', value: Nome, onChange: function (event) { return setNome(event.target.value); }, variant: 'outlined', size: 'small', fullWidth: true, disabled: DESABILITAR_CAMPOS, required: true }), _jsx(InputDados, { id: 'rota', label: 'Rota', value: Rota, onChange: function (event) { return setRota(event.target.value); }, variant: 'outlined', size: 'small', fullWidth: true, disabled: DESABILITAR_CAMPOS, required: true }), _jsx(InputDados, { id: 'descricao', label: 'Descricao', value: Descricao, onChange: function (event) { return setDescricao(event.target.value); }, multiline: true, variant: 'outlined', size: 'small', fullWidth: true, disabled: DESABILITAR_CAMPOS, maxLength: 1000 }), _jsxs(InputDados, __assign({ select: true, id: 'situacao' // obrigatorio
                            , label: 'Situa\u00E7\u00E3o' // obrigatorio
                            , placeholder: 'Situa\u00E7\u00E3o', value: Situacao, onChange: function (event) {
                                setSituacao(event.target.value);
                            }, size: 'small', fullWidth: true, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: 'Ativo' }, { children: "Ativo" })), _jsx(MenuItem, __assign({ value: 'Inativo' }, { children: "Inativo" }))] })), _jsx(Divider, __assign({ style: { marginTop: 15, marginBottom: 0, color: 'grey' } }, { children: "A\u00C7\u00D5ES" })), _jsxs(Box, __assign({ mb: 2, p: 2, border: 1, borderColor: 'grey.300', borderRadius: 4 }, { children: [_jsx(Box, __assign({ mt: 2 }, { children: _jsx(Button, __assign({ style: { marginBottom: 20 }, variant: 'outlined', color: 'secondary', startIcon: _jsx(Delete, {}), onClick: function () { return setAcoesSelecionadas(AcoesDisponiveis); }, size: 'small', disabled: DESABILITAR_CAMPOS }, { children: "Resetar" })) })), AcoesSelecionadas === null || AcoesSelecionadas === void 0 ? void 0 : AcoesSelecionadas.map(function (acao, AcaoIndex) { return (_jsxs(Box, __assign({ display: 'flex', alignItems: 'center', mb: 1, mt: 1 }, { children: [_jsx(InputDados, { label: 'A\u00E7\u00E3o', value: acao.nome, size: 'small', variant: 'standard', disabled: true, inputProps: { style: { fontSize: 14 } } }), !DESABILITAR_CAMPOS && (_jsx(IconButton, __assign({ onClick: function () { return removerAcao(acao.id); } }, { children: _jsx(Delete, {}) })))] }), AcaoIndex)); })] })), _jsxs(BoxBotoes, { children: [(MODOS.ALTERAR == modo || MODOS.CADASTRAR == modo) && _jsx(BotaoSalvar, { onClick: salvarDados }), MODOS.EXCLUIR == modo && _jsx(BotaoExcluir, { onClick: excluirRegistro }), MODOS.VISUALIZAR == modo && _jsx(BotaoEditar, { onClick: editarRegistro }), _jsx(BotaoFechar, { modo: modo })] })] })), loading && _jsx(Loading, {})] }) })));
};
export default FuncionalidadesEditar;
